import { render, staticRenderFns } from "./SubastaModalGanOferta.vue?vue&type=template&id=941e130e"
import script from "./SubastaModalGanOferta.vue?vue&type=script&lang=js"
export * from "./SubastaModalGanOferta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports